// services/exerciseApi.js
import axios from "axios";
import axiosInstance from "./AxiosInstance";

// Get Exercise Plan
export const getExercisePlan = (planInitiateTime , nextPrevious , hasNextPage , hasPreviousPage) => {

    let params = {};
  
  // Determine which parameters to send based on nextPrevious value
  if (nextPrevious === 'previous') {
    params = {
      date: planInitiateTime,
      fetch_previous: hasPreviousPage,
    };
  } else if (nextPrevious === 'next') {
    params = {
      date: planInitiateTime,
      fetch_next: hasNextPage
    };
  } else {
    // Default case - no navigation
    params = {};
  }

  return axiosInstance.get("/api/exercise/get-plan", { params });
};

// Get Categories
export const getExerciseCategories = () => {
  return axiosInstance.get("/api/get/categories");
};

// Save Categories
export const saveExerciseCategories = (preferences) => {
  return axiosInstance.post("api/update/all-form-fields", { preferences });
};

// Generate Exercise Plan
export const generateExercisePlan = async () => {
  const now = new Date();
  const start_time = `${now.getFullYear()}-${String(
    now.getMonth() + 1
  ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours()
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
  const response = await axiosInstance.post("api/exercise/create-plan", {
    start_time,
  });
  return response?.data;
};

export const fetchExercise = async (day) => {
  try {
    const response = await axiosInstance.get("api/exercise/get-plan/day", {
      params: {
        day,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sleep coach steps:", error);
    throw error;
  }
};
export const getWorkoutMetadata = async () => {
  try {
    const url = `${process.env.REACT_APP_HYPER_HUMAN_URL}workouts/metadata`;

    const response = await axios.get(url, {
      headers: {
        // --- IMPORTANT: CHANGE 'X-Api-Key' if Hyperhuman uses a different header name ---
        "X-Api-Key": process.env.REACT_APP_HYPER_HUMAN_API_KEY,
        // --------------------------------------------------------------------------------
      },
    });

    // The API returns { categories: [...], difficulties: [...] }
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching workout metadata:",
      error.response ? error.response.data : error.message
    );
    // Throw error or return a default empty structure to prevent app crash
    throw error;
  }
};

export const getEquipmentMetadata = async () => {
  try {
    const url = `${process.env.REACT_APP_HYPER_HUMAN_URL}workouts/equipment/metadata`;

    const response = await axios.get(url, {
      headers: {
        "X-Api-Key": process.env.REACT_APP_HYPER_HUMAN_API_KEY,
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching equipment metadata:",
      error.response ? error.response.data : error.message
    );
    // Throw error or return a default empty structure
    throw error;
  }
};


export const downloadExercisePlan = (payload) => {
  return axiosInstance.get(`api/exercise/pdf/day`, {
    responseType: "blob",
    params: payload,
  });
};